import { graphql } from 'gatsby';
import React from 'react';
import SvgSafeGatsbyImage from '../../atoms/SvgSafeGatsbyImage';
import paddingDefault from '../../utils/paddingDefault';
import Container from '../../primitives/grid/container';
import Link from '../../primitives/link';
import { breakpoints } from '../../primitives/tokens';
import Typography from '../../primitives/typography';

export type TeamMembersBlock = Queries.TeamMembersDataFragment['team_member_grid'];

const TeamMembers = ({ data }: { data: TeamMembersBlock }): JSX.Element => {
    const teamMembers = data?.team_members;

    return (
        <section css={paddingDefault()}>
            <Container>
                <ul css={{
                    display: 'grid',
                    gap: '48px',
                    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                    [breakpoints.tb]: {
                        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    },
                    [breakpoints.mb]: {
                        gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
                    },
                }}
                >
                    {(teamMembers || []).map((member) => {
                        const { company_title: job, headshot, title: name, url } = member || {};

                        if (!job || !headshot?.contentStackAsset || !name) {
                            return null;
                        }

                        return (
                            <li
                                css={{
                                    position: 'relative',
                                    paddingTop: '20px',
                                }}
                                key={name}
                            >
                                <Link to={url || '#'}>
                                    <div
                                        css={{
                                            position: 'relative',
                                            marginBottom: '20px',
                                            '&:after': {
                                                display: 'block',
                                                paddingTop: '86%',
                                                content: '""',
                                            },
                                        }}
                                    >
                                        <SvgSafeGatsbyImage
                                            css={{
                                                position: 'absolute',
                                                top: '0',
                                                left: '0',
                                                height: '100%',
                                                width: '100%',
                                                objectFit: 'cover',
                                            }}
                                            image={headshot as Queries.Cms_assets}
                                            alt={headshot.title || ''}
                                        />
                                    </div>
                                    <Typography as="h3" fontWeight="medium" color="grey600" fontSize="xl">
                                        {name}
                                    </Typography>
                                    <Typography as="p" fontWeight="medium" color="grey500" css={{ width: '80%' }}>
                                        {job}
                                    </Typography>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </Container>
        </section>
    );
};

export const query = graphql`
  fragment TeamMembersData on CmsPageBuilderBlocks {
    team_member_grid {
      team_members {
        url
        title
        company_title
        headshot {
          filename
          title
          url
          contentStackAsset(width: 1440)
        }
      }
    }
  }
`;

export default TeamMembers;
